import React from 'react';
import LabelSwitch from 'src/modules/shared/components/atoms/inputs/label-switch';
import Select from 'src/modules/shared/components/atoms/inputs/select';
import { BaseFieldProps } from 'src/modules/shared/types/json-schema.type';

const convertBooleanToString = (
  value: boolean | null | undefined | unknown
): string => {
  if (value === null) return '';
  if (value === true) return 'true';
  if (value === false) return 'false';
  return '';
};

/**
 * Props for BooleanField component
 */
export interface BooleanFieldProps extends BaseFieldProps {
  label?: string;
}

/**
 * Boolean field component for JSON Schema form
 * Renders as switch or select dropdown (if nullable)
 */
export const BooleanField: React.FC<BooleanFieldProps> = ({
  id,
  value,
  onChange,
  disabled = false,
  nullable = false,
  label = '',
}) => {
  if (!nullable) {
    return (
      <LabelSwitch
        label={label}
        checked={!!value}
        onChange={(checked) => onChange(checked)}
        disabled={disabled}
        variant="primary"
        size="sm"
      />
    );
  }

  // TODO: check when implementing i18n
  const options = [
    { value: '', content: 'Sin valor (nulo)' },
    { value: 'true', content: 'Sí' },
    { value: 'false', content: 'No' },
  ];

  const boolValue = convertBooleanToString(value);

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    let val;
    if (e.target.value === '') val = null;
    else if (e.target.value === 'true') val = true;
    else if (e.target.value === 'false') val = false;
    onChange(val);
  };

  return (
    <Select
      id={id}
      value={boolValue}
      onChange={handleChange}
      disabled={disabled}
      options={options}
      variant="primary"
    />
  );
};
